import React from "react";
import { Link } from "react-router-dom";
import { company } from "@/config/site";

// Abstract "P" formed by interconnected trade-route segments with a directional
// arrow and a single copper-gold connection node. Editable, SVG-ready.
export const LogoMark = ({ size = 40, navy = "#09243D", teal = "#0B6E69", node = "#D28A32", className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    className={className}
    role="img"
    aria-label={`${company.name} logo mark`}
  >
    {/* Vertical stem route */}
    <path d="M12 8 V40" stroke={navy} strokeWidth="3" strokeLinecap="round" />
    {/* Bowl of the P as connected route segments */}
    <path
      d="M12 8 H28 L36 16 L28 24 H12"
      stroke={teal}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    {/* Directional arrow along the route */}
    <path d="M31 16 l4 0 l-2 -2 M35 16 l-2 2" stroke={navy} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    {/* Junction nodes */}
    <circle cx="12" cy="8" r="2.6" fill={navy} />
    <circle cx="12" cy="24" r="2.2" fill={teal} />
    <circle cx="12" cy="40" r="2.2" fill={navy} />
    {/* Copper-gold connection node */}
    <circle cx="36" cy="16" r="3.2" fill={node} />
  </svg>
);

export const Logo = ({ variant = "horizontal", size = 38, className = "" }) => {
  const isWhite = variant === "white";
  const isMono = variant === "mono";

  const markProps = isWhite
    ? { navy: "#FFFFFF", teal: "#FFFFFF", node: "#D28A32" }
    : isMono
    ? { navy: "#14202B", teal: "#14202B", node: "#14202B" }
    : {};

  const textColor = isWhite ? "text-white" : isMono ? "text-[#14202B]" : "text-navy";

  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <LogoMark size={size} {...markProps} />
      <span className="flex flex-col leading-none">
        <span className={`font-heading font-extrabold tracking-tight ${textColor} text-[17px]`}>
          Premier Global
        </span>
        <span className={`font-heading font-semibold tracking-[0.14em] uppercase text-[10px] ${isWhite ? "text-white/70" : "text-teal"}`}>
          Sourcing
        </span>
      </span>
    </span>
  );
};

export const LogoLink = ({ variant = "horizontal", size = 38 }) => (
  <Link to="/" aria-label={`${company.name} — home`} data-testid="logo-home-link">
    <Logo variant={variant} size={size} />
  </Link>
);

export default Logo;
